import { clsx } from 'clsx'
import { extendTailwindMerge } from 'tailwind-merge'
import fontSizes from 'src/common/constants/tailwindFontSizes'

// tailwind-merge only knows Tailwind's default font sizes; without this, custom
// ones like `text-14` are read as text colors and drop `text-white`.
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': [{ text: Object.keys(fontSizes) }],
    },
  },
})

export const cn = (...inputs) => {
  return twMerge(clsx(inputs))
}
